// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicNewApplicationReceived } from "./plasmic/collect_wise_draft/PlasmicNewApplicationReceived";
import {useNavigate} from 'react-router-dom'

function NewApplicationReceived_(props, ref) {
 
  const navigate = useNavigate()

  return <PlasmicNewApplicationReceived root={{ ref }} {...props} 
  continueButton={{
    onClick: () => {
      navigate("/")
    }
  }}
  />;
}

const NewApplicationReceived = React.forwardRef(NewApplicationReceived_);

export default NewApplicationReceived;
